<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="page">
            <div class="atendimento">
                <h1 class="title">{{ $t('atendimentos-ppt') }}</h1>
                <nav class="breadcrumb" aria-label="breadcrumbs">
                    <ul>
                        <li>
                            <a>{{ $t('promotor') }}</a>
                        </li>
                        <li>
                            <a>{{ $t('relatorios') }}</a>
                        </li>
                        <li>
                            <a href="#" aria-current="page">{{ $t('atendimentos-ppt') }}</a>
                        </li>
                    </ul>
                </nav>
            </div>
            <div class="filter relatorio-atendimento-ppt">
                <div class="items">
                    <div class="item-input">
                        <label for="regiao" v-text="$t('regiao')" />
                        <v-select
                            multiple
                            ref="regiaoInput"
                            v-model="atendimento.regioes"
                            :options="regioes"
                            :loading="loading.regiao"
                            @search="loadRegiao"
                            @input="updateRegiao"
                        >
                            <template slot="no-options">{{ $t('sem-resultados-filtro') }}</template>
                        </v-select>
                    </div>
                    <div class="item-input">
                        <label for="estado" v-text="$t('estado')" />
                        <v-select
                            multiple
                            ref="estadoInput"
                            v-model="atendimento.estados"
                            :options="estados"
                            :loading="loading.estado"
                            @search="loadEstado"
                            @input="updateEstado"
                        >
                            <template slot="no-options">{{ $t('sem-resultados-filtro') }}</template>
                        </v-select>
                    </div>
                    <div class="item-input">
                        <label for="cidade" v-text="$t('cidade')" />
                        <v-select
                            multiple
                            ref="cidadeInput"
                            v-model="atendimento.cidades"
                            :options="cidades"
                            :loading="loading.cidade"
                            @search="loadCidade"
                            @input="updateCidade"
                        >
                            <template slot="no-options">{{ $t('sem-resultados-filtro') }}</template>
                        </v-select>
                    </div>
                    <div class="item-input">
                        <label for="promotor" v-text="$t('promotor')" />
                        <v-select
                            multiple
                            ref="promotorInput"
                            v-model="atendimento.promotores"
                            :options="promotores"
                            :loading="loading.promotor"
                            @search="loadColaborador"
                            @input="updateColaborador"
                        >
                            <template slot="no-options">{{ $t('sem-resultados-filtro') }}</template>
                        </v-select>
                    </div>
                    <div class="item-input">
                        <label for="cliente" v-text="$t('cliente')" />
                        <v-select
                            multiple
                            ref="clienteInput"
                            v-model="atendimento.clientes"
                            :options="clientes"
                            :loading="loading.cliente"
                            @search="loadCliente"
                            @input="updateCliente"
                        >
                            <template slot="no-options">{{ $t('sem-resultados-filtro') }}</template>
                        </v-select>
                    </div>
                    <div class="item-input">
                        <label for="contrato" v-text="$t('contrato')" />
                        <v-select
                            multiple
                            ref="contratoInput"
                            v-model="atendimento.contratos"
                            :options="contratos"
                            :loading="loading.contrato"
                            @search="loadContrato"
                            @input="updateContrato"
                        >
                            <template slot="no-options">{{ $t('sem-resultados-filtro') }}</template>
                        </v-select>
                    </div>
                    <div class="item-input">
                        <label for="rede" v-text="$t('rede')" />
                        <v-select
                            multiple
                            ref="redeInput"
                            v-model="atendimento.redes"
                            :options="redes"
                            :loading="loading.rede"
                            @search="loadRede"
                            @input="updateRede"
                        >
                            <template slot="no-options">{{ $t('sem-resultados-filtro') }}</template>
                        </v-select>
                    </div>
                    <div class="item-input">
                        <label for="bandeira" v-text="$t('bandeira')" />
                        <v-select
                            multiple
                            ref="bandeiraInput"
                            v-model="atendimento.bandeiras"
                            :options="bandeiras"
                            :loading="loading.bandeira"
                            @search="loadBandeira"
                            @input="updateBandeira"
                        >
                            <template slot="no-options">{{ $t('sem-resultados-filtro') }}</template>
                        </v-select>
                    </div>
                    <div class="item-input">
                        <label for="lps" v-text="$t('lps')" />
                        <v-select
                            multiple
                            ref="lpsInput"
                            v-model="atendimento.lpss"
                            :options="lpss"
                            :loading="loading.lps"
                            @search="loadLps"
                            @input="updateLps"
                        >
                            <template slot="no-options">{{ $t('sem-resultados-filtro') }}</template>
                        </v-select>
                    </div>
                    <div class="item-input">
                        <label for="tipo-servico" v-text="$t('tipo-servico')" />
                        <v-select
                            multiple
                            ref="tsInput"
                            v-model="atendimento.tiposservicos"
                            :options="tiposservicos"
                            :loading="loading.tiposervico"
                            @search="loadTS"
                            @input="updateTiposervico"
                        >
                            <template slot="no-options">{{ $t('sem-resultados-filtro') }}</template>
                        </v-select>
                    </div>
                    <div class="item-input">
                        <label for="grupo" v-text="$t('grupo')" />
                        <v-select
                            multiple
                            ref="grupoInput"
                            v-model="atendimento.grupos"
                            :options="grupos"
                            :loading="loading.grupo"
                            @search="loadGrupo"
                            @input="updateGrupo"
                        >
                            <template slot="no-options">{{ $t('sem-resultados-filtro') }}</template>
                        </v-select>
                    </div>
                    <div class="item-input">
                        <label for="subgrupo" v-text="$t('subgrupo')" />
                        <v-select
                            multiple
                            ref="subgrupoInput"
                            v-model="atendimento.subgrupos"
                            :options="subgrupos"
                            :loading="loading.subgrupo"
                            @search="loadSubgrupo"
                            @input="updateSubgrupo"
                        >
                            <template slot="no-options">{{ $t('sem-resultados-filtro') }}</template>
                        </v-select>
                    </div>
                    <div class="item-input x2">
                        <label for="linha-produto" v-text="$t('linha-produto')" />
                        <v-select
                            multiple
                            ref="linhaprodutoInput"
                            v-model="atendimento.linhasprodutos"
                            :options="linhasprodutos"
                            :loading="loading.linha"
                            @search="loadLinha"
                            @input="updateLinha"
                        >
                            <template slot="no-options">{{ $t('sem-resultados-filtro') }}</template>
                        </v-select>
                    </div>
                    <div class="item-input x2">
                        <label for="produto" v-text="$t('produto')" />
                        <v-select
                            multiple
                            ref="produtoInput"
                            v-model="atendimento.produtos"
                            :options="produtos"
                            :loading="loading.produto"
                            @search="loadProduto"
                            @input="updateProduto"
                        >
                            <template slot="no-options">{{ $t('sem-resultados-filtro') }}</template>
                        </v-select>
                    </div>
                </div>
                <div class="result-options">
                    <div class="result-list" :class="isSearching ? 'block-events' : ''">
                        <label class="radio-box" for="ruptura">
                            {{ $t('ruptura-troca') }}
                            <input
                                type="radio"
                                name="report"
                                id="ruptura"
                                value="r"
                                v-model="atendimento.tipo"
                                @change="updateResultOption"
                            />
                            <span class="checkmark"></span>
                        </label>
                        <label class="radio-box" for="share">
                            {{ $t('share') }}
                            <input
                                type="radio"
                                name="report"
                                id="share"
                                value="s"
                                v-model="atendimento.tipo"
                                @change="updateResultOption"
                            />
                            <span class="checkmark"></span>
                        </label>
                        <label class="radio-box" for="tomada-preco">
                            {{ $t('tomada-preco') }}
                            <input
                                type="radio"
                                name="report"
                                id="tomada-preco"
                                value="t"
                                v-model="atendimento.tipo"
                                @change="updateResultOption"
                            />
                            <span class="checkmark"></span>
                        </label>
                        <label class="radio-box" for="vencimento">
                            {{ $t('vencimento') }}
                            <input
                                type="radio"
                                name="report"
                                id="vencimento"
                                value="v"
                                v-model="atendimento.tipo"
                                @change="updateResultOption"
                            />
                            <span class="checkmark"></span>
                        </label>
                        <label class="radio-box" for="fotos">
                            {{ $t('fotos') }}
                            <input
                                type="radio"
                                name="report"
                                id="fotos"
                                value="f"
                                v-model="atendimento.tipo"
                                @change="updateResultOption"
                            />
                            <span class="checkmark"></span>
                        </label>
                    </div>

                    <div class="inicio-input">
                        <verified-date-picker
                            dateType="startDate"
                            v-model="atendimento.datainicial"
                            :endDate="atendimento.datafinal"
                            title="inicio"
                            @input="changeStartDate"
                            :inForm="true"
                        />
                    </div>

                    <div class="fim-input">
                        <verified-date-picker
                            dateType="endDate"
                            v-model="atendimento.datafinal"
                            :startDate="atendimento.datainicial"
                            title="fim"
                            @input="changeEndDate"
                        />
                    </div>
                </div>
            </div>
            <div class="columns mt-0 mb-2">
                <div class="column is-4 has-text-centered">
                    <button
                        class="save-btn pl-4 pr-4"
                        @click="searchFilter()"
                        :disabled="isSearching || !datasValidas"
                    >
                        {{ $t('pesquisar') }}
                        <svg class="svg-loader dark" v-if="isSearching">
                            <use
                                :xlink:href="require('@/assets/img/icons/loader.svg') + '#layer'"
                            ></use>
                        </svg>
                    </button>
                </div>
                <div class="column is-4 has-text-centered">
                    <button class="delete-btn pl-4 pr-4" @click="confirmClearFields">
                        {{ $t('limpar-campos') }}
                    </button>
                </div>
                <div class="column is-4 has-text-centered">
                    <button
                        class="delete-btn pl-4 pr-4"
                        v-if="permissao.export"
                        @click="exportPPT()"
                        :disabled="isExportingPPT || !datasValidas"
                    >
                        {{ $t('exportar-ppt') }}
                        <svg class="svg-loader dark" v-if="isExportingPPT">
                            <use
                                :xlink:href="require('@/assets/img/icons/loader.svg') + '#layer'"
                            ></use>
                        </svg>
                    </button>
                </div>
            </div>
            <div class="results-table">
                <b-table
                    ref="resultsTable"
                    :key="tableKey"
                    :data="atendimentos.length > 0 && !isSearching ? atendimentos : [{}]"
                    class="data-table"
                    paginated
                    :current-page="currentPage"
                    :per-page="perPage"
                >
                    <b-table-column
                        v-for="f in fields"
                        :key="f.key"
                        :field="f.key"
                        :label="f.label != '' ? $t(f.label) : ''"
                        :sortable="f.sortable"
                        :visible="f.visible"
                        v-slot="props"
                    >
                        <div>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>
            </div>
        </div>
    </div>
</template>
<script>
import RegiaoService from '@/services/RegiaoService.js';
import EstadoService from '@/services/EstadoService.js';
import CidadeService from '@/services/CidadeService.js';
import ColaboradorService from '@/services/ColaboradorService.js';
import ClienteService from '@/services/promotor/ClienteService.js';
import ProContratoService from '@/services/promotor/pro_cliente/ProContratoService.js';
import RedeService from '@/services/promotor/RedeService.js';
import BandeiraService from '@/services/promotor/BandeiraService.js';
import ProLpsService from '@/services/promotor/ProLpsService.js';
import TipoServicoService from '@/services/promotor/TipoServicoService.js';
import GrupoProdutoService from '@/services/GrupoProdutoService.js';
import SubGrupoProdutoService from '@/services/SubGrupoProdutoService.js';
import LinhaProdutoService from '@/services/LinhaProdutoService.js';
import ProProdutoService from '@/services/promotor/ProProdutoService.js';
import AtendimentoPPTService from '@/services/AtendimentoPPTService.js';

export default {
    data() {
        return {
            tableKey: 0,
            dadosTabela: [],
            dadosAgrupamento: [],
            dadosTabelaAgrupado: [],
            isExportingPPT: false,
            isSearching: false,
            isLoading: false,
            regiao: null,
            regioes: [],
            estado: null,
            estados: [],
            cidade: null,
            cidades: [],
            promotor: null,
            promotores: [],
            cliente: null,
            clientes: [],
            contrato: null,
            contratos: [],
            rede: null,
            redes: [],
            bandeira: null,
            bandeiras: [],
            lps: null,
            lpss: [],
            tiposervico: null,
            tiposservicos: [],
            grupo: null,
            grupos: [],
            subgrupo: null,
            subgrupos: [],
            linhaproduto: null,
            linhasprodutos: [],
            produto: null,
            produtos: [],
            atendimentos: [],
            options: [
                { id: 'PDF', label: 'PDF' },
                { id: 'XLS', label: 'XLS' },
                { id: 'PPT', label: 'PPT' },
            ],
            formato: { id: 'PDF', label: 'PDF' },
            report: 'r',
            isLoading: false,
            service: null,
            regiaoService: null,
            estadoService: null,
            cidadeService: null,
            colaboradorService: null,
            clienteService: null,
            contratoService: null,
            redeService: null,
            bandeiraService: null,
            lpsService: null,
            tiposervicoService: null,
            grupoService: null,
            subgrupoService: null,
            linhaService: null,
            produtoService: null,
            fields: [
                { key: 'estado-descricao', label: 'uf', visible: true, sortable: true },
                { key: 'cidade-descricao', label: 'cidade', visible: true, sortable: true },
                { key: 'promotor', label: 'promoter', visible: true, sortable: true },
                { key: 'cliente', label: 'cliente', visible: true, sortable: true },
                { key: 'lps', label: 'lps', visible: true, sortable: true },
                { key: 'numberRpShTpV', label: 'ruptura-troca', visible: true, sortable: true },
                { key: 'photo', label: 'fotos', visible: true, sortable: true },
            ],
            currentPage: 1,
            perPage: 20,
            totalRows: 0,
            atendimento: {
                regioes: [],
                estados: [],
                cidades: [],
                promotores: [],
                clientes: [],
                contratos: [],
                redes: [],
                bandeiras: [],
                lpss: [],
                tiposservicos: [],
                grupos: [],
                subgrupos: [],
                linhasprodutos: [],
                produtos: [],
                datainicial: null,
                datafinal: null,
                tipo: 'r',
            },
            loading: {
                regiao: false,
                estado: false,
                cidade: false,
                promotor: false,
                cliente: false,
                contrato: false,
                rede: false,
                bandeira: false,
                lps: false,
                tiposervico: false,
                grupo: false,
                subgrupo: false,
                linha: false,
                produto: false,
            },
            datasValidas: true,
            canSelectRegiao: false,
            canSelectEstado: false,
            canSelectCidade: false,
            canSelectPromotor: false,
            canSelectCliente: false,
            canSelectContrato: false,
            canSelectRede: false,
            canSelectBandeira: false,
            canSelectLps: false,
            canSelectTS: false,
            canSelectGrupo: false,
            canSelectSubGrupo: false,
            canSelectLinha: false,
            canSelectProduto: false,
            permissao: {},
            empresas: [],
        };
    },

    created() {
        this.permissao = this.hasPermissionAccess('promotor', 'relatorios', 'report-rota-ppt');

        !this.permissao.read &&
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'atendimentos-ppt' },
            });

        this.service = new AtendimentoPPTService(this.$http, this.$router);
        this.regiaoService = new RegiaoService(this.$http, this.$router);
        this.estadoService = new EstadoService(this.$http, this.$router);
        this.cidadeService = new CidadeService(this.$http, this.$router);
        this.colaboradorService = new ColaboradorService(this.$http, this.$router);
        this.clienteService = new ClienteService(this.$http, this.$router);
        this.contratoService = new ProContratoService(this.$http, this.$router);
        this.redeService = new RedeService(this.$http, this.$router);
        this.bandeiraService = new BandeiraService(this.$http, this.$router);
        this.lpsService = new ProLpsService(this.$http, this.$router);
        this.tiposervicoService = new TipoServicoService(this.$http, this.$router);
        this.grupoService = new GrupoProdutoService(this.$http, this.$router);
        this.subgrupoService = new SubGrupoProdutoService(this.$http, this.$router);
        this.linhaService = new LinhaProdutoService(this.$http, this.$router);
        this.produtoService = new ProProdutoService(this.$http, this.$router);
        this.loadEmpresas();

        this.initDate();
        this.loadAllRegiao();
    },
    mounted() {
        let regiaoSearch = this.$refs.regiaoInput.$refs.search;
        regiaoSearch.focus();
        regiaoSearch.addEventListener('focusin', () => this.loadAllRegiao());
        regiaoSearch.addEventListener('keydown', this.tabSelectRegiao);

        let estadoSearch = this.$refs.estadoInput.$refs.search;
        estadoSearch.addEventListener('focusin', () => this.loadAllEstado());
        estadoSearch.addEventListener('keydown', this.tabSelectEstado);

        let cidadeSearch = this.$refs.cidadeInput.$refs.search;
        cidadeSearch.addEventListener('focusin', () => this.loadAllCidade());
        cidadeSearch.addEventListener('keydown', this.tabSelectCidade);

        let promotorSearch = this.$refs.promotorInput.$refs.search;
        promotorSearch.addEventListener('focusin', () => this.loadAllColaborador());
        promotorSearch.addEventListener('keydown', this.tabSelectPromotor);

        let clienteSearch = this.$refs.clienteInput.$refs.search;
        clienteSearch.addEventListener('focusin', () => this.loadAllCliente());
        clienteSearch.addEventListener('keydown', this.tabSelectCliente);

        let contratoSearch = this.$refs.contratoInput.$refs.search;
        contratoSearch.addEventListener('focusin', () => this.loadAllContrato());
        contratoSearch.addEventListener('keydown', this.tabSelectContrato);

        let redeSearch = this.$refs.redeInput.$refs.search;
        redeSearch.addEventListener('focusin', () => this.loadAllRede());
        redeSearch.addEventListener('keydown', this.tabSelectRede);

        let bandeiraSearch = this.$refs.bandeiraInput.$refs.search;
        bandeiraSearch.addEventListener('focusin', () => this.loadAllBandeira());
        bandeiraSearch.addEventListener('keydown', this.tabSelectBandeira);

        let lpsSearch = this.$refs.lpsInput.$refs.search;
        lpsSearch.addEventListener('focusin', () => this.loadAllLps());
        lpsSearch.addEventListener('keydown', this.tabSelectLps);

        let tsSearch = this.$refs.tsInput.$refs.search;
        tsSearch.addEventListener('focusin', () => this.loadAllTS());
        tsSearch.addEventListener('keydown', this.tabSelectTS);

        let grupoSearch = this.$refs.grupoInput.$refs.search;
        grupoSearch.addEventListener('focusin', () => this.loadAllGrupo());
        grupoSearch.addEventListener('keydown', this.tabSelectGrupo);

        let subgrupoSearch = this.$refs.subgrupoInput.$refs.search;
        //subgrupoSearch.addEventListener("focusin", () => this.loadAllSubgrupo());
        subgrupoSearch.addEventListener('keydown', this.tabSelectSubGrupo);

        let linhaprodutoSearch = this.$refs.linhaprodutoInput.$refs.search;
        //linhaprodutoSearch.addEventListener("focusin", () => this.loadAllLinha());
        linhaprodutoSearch.addEventListener('keydown', this.tabSelectLinha);

        let produtoSearch = this.$refs.produtoInput.$refs.search;
        produtoSearch.addEventListener('focusin', () => this.loadAllProduto());
        produtoSearch.addEventListener('keydown', this.tabSelectProduto);
    },
    methods: {
        loadEmpresas() {
            if (this.$store.state.user.admin) {
                // se for admin, mostra todas as empresas
                this.$store.state.empresas.data.map((e) => {
                    this.empresas.push({ id: `${e.id}`, label: e.rsocial });
                });
            } else {
                // se for cliente, mostra todas as empresas relacionadas a ele
                this.$store.state.user.empresas.map((e) => {
                    this.empresas.push({ id: `${e.id}`, label: e.rsocial });
                });
            }
        },
        confirmClearFields() {
            this.$root.confirm({
                message: this.$t('msg-confirm-limpar-campos'),
                onConfirm: this.clearFields,
            });
        },
        tabSelectGrupo(e) {
            if (e.code == 'ArrowUp' || e.code == 'ArrowDown') this.canSelectGrupo = true;
            if (e.code == 'Tab' && this.canSelectGrupo) {
                this.$refs.grupoInput.typeAheadSelect();
                this.$refs.grupoInput.$refs.search.focus();
                this.canSelectGrupo = false;
            }
        },
        tabSelectSubGrupo(e) {
            if (e.code == 'ArrowUp' || e.code == 'ArrowDown') this.canSelectSubGrupo = true;
            if (e.code == 'Tab' && this.canSelectSubGrupo) {
                this.$refs.subgrupoInput.typeAheadSelect();
                this.$refs.subgrupoInput.$refs.search.focus();
                this.canSelectSubGrupo = false;
            }
        },
        tabSelectLinha(e) {
            if (e.code == 'ArrowUp' || e.code == 'ArrowDown') this.canSelectLinha = true;
            if (e.code == 'Tab' && this.canSelectLinha) {
                this.$refs.linhaprodutoInput.typeAheadSelect();
                this.$refs.linhaprodutoInput.$refs.search.focus();
                this.canSelectLinha = false;
            }
        },
        tabSelectCidade(e) {
            if (e.code == 'ArrowUp' || e.code == 'ArrowDown') this.canSelectCidade = true;
            if (e.code == 'Tab' && this.canSelectCidade) {
                this.$refs.cidadeInput.typeAheadSelect();
                this.$refs.cidadeInput.$refs.search.focus();
                this.canSelectCidade = false;
            }
        },
        tabSelectEstado(e) {
            if (e.code == 'ArrowUp' || e.code == 'ArrowDown') this.canSelectEstado = true;
            if (e.code == 'Tab' && this.canSelectEstado) {
                this.$refs.estadoInput.typeAheadSelect();
                this.$refs.estadoInput.$refs.search.focus();
                this.canSelectEstado = false;
            }
        },
        tabSelectRegiao(e) {
            if (e.code == 'ArrowUp' || e.code == 'ArrowDown') this.canSelectRegiao = true;
            if (e.code == 'Tab' && this.canSelectRegiao) {
                this.$refs.regiaoInput.typeAheadSelect();
                this.$refs.regiaoInput.$refs.search.focus();
                this.canSelectRegiao = false;
            }
        },
        tabSelectPromotor(e) {
            if (e.code == 'ArrowUp' || e.code == 'ArrowDown') this.canSelectPromotor = true;
            if (e.code == 'Tab' && this.canSelectPromotor) {
                this.$refs.promotorInput.typeAheadSelect();
                this.$refs.promotorInput.$refs.search.focus();
                this.canSelectPromotor = false;
            }
        },
        tabSelectContrato(e) {
            if (e.code == 'ArrowUp' || e.code == 'ArrowDown') this.canSelectContrato = true;
            if (e.code == 'Tab' && this.canSelectContrato) {
                this.$refs.contratoInput.typeAheadSelect();
                this.$refs.contratoInput.$refs.search.focus();
                this.canSelectContrato = false;
            }
        },
        tabSelectCliente(e) {
            if (e.code == 'ArrowUp' || e.code == 'ArrowDown') this.canSelectCliente = true;
            if (e.code == 'Tab' && this.canSelectCliente) {
                this.$refs.clienteInput.typeAheadSelect();
                this.$refs.clienteInput.$refs.search.focus();
                this.canSelectCliente = false;
            }
        },
        tabSelectRede(e) {
            if (e.code == 'ArrowUp' || e.code == 'ArrowDown') this.canSelectRede = true;
            if (e.code == 'Tab' && this.canSelectRede) {
                this.$refs.redeInput.typeAheadSelect();
                this.$refs.redeInput.$refs.search.focus();
                this.canSelectRede = false;
            }
        },
        tabSelectLps(e) {
            if (e.code == 'ArrowUp' || e.code == 'ArrowDown') this.canSelectLps = true;
            if (e.code == 'Tab' && this.canSelectLps) {
                this.$refs.lpsInput.typeAheadSelect();
                this.$refs.lpsInput.$refs.search.focus();
                this.canSelectLps = false;
            }
        },
        tabSelectBandeira(e) {
            if (e.code == 'ArrowUp' || e.code == 'ArrowDown') this.canSelectBandeira = true;
            if (e.code == 'Tab' && this.canSelectBandeira) {
                this.$refs.bandeiraInput.typeAheadSelect();
                this.$refs.bandeiraInput.$refs.search.focus();
                this.canSelectBandeira = false;
            }
        },
        tabSelectTS(e) {
            if (e.code == 'ArrowUp' || e.code == 'ArrowDown') this.canSelectTS = true;
            if (e.code == 'Tab' && this.canSelectTS) {
                this.$refs.tsInput.typeAheadSelect();
                this.$refs.tsInput.$refs.search.focus();
                this.canSelectTS = false;
            }
        },
        tabSelectProduto(e) {
            if (e.code == 'ArrowUp' || e.code == 'ArrowDown') this.canSelectProduto = true;
            if (e.code == 'Tab' && this.canSelectProduto) {
                this.$refs.produtoInput.typeAheadSelect();
                this.$refs.produtoInput.$refs.search.focus();
                this.canSelectProduto = false;
            }
        },
        mapItems(body) {
            let list = body.content.map((i) => {
                return {
                    id: i.id,
                    obj: i,
                    label: i.descricao,
                };
            });
            return list;
        },
        mapItemsPromotor(body) {
            let list = body.content.map((i) => {
                return {
                    id: i.id,
                    obj: i,
                    label: i.nome,
                };
            });
            return list;
        },
        loadAllRegiao() {
            if (this.regioes.length == 0) {
                this.loadRegiao();
            }
        },
        loadRegiao(value) {
            this.loading.regiao = true;

            let empresa = '0, ';
            for (let e of this.empresas) {
                if (e.id > 0) {
                    empresa += `${e.id}, `;
                }
            }
            empresa = empresa.slice(0, -2);

            this.regiaoService

                .findAll('descricao', 'asc', empresa, 0, 100, 2, value ? value : '')
                .then(this.mapItems)
                .then((allregioes) => {
                    let o = allregioes.filter(
                        (c) => this.regiao && c.id.idregiao == this.regiao.id.idregiao
                    )[0];
                    if (this.regiao && !o) {
                        allregioes.push(this.regiao);
                    }
                    this.regioes = allregioes;
                    this.regioes.sort();
                }, 350)
                .catch((e) => {
                    console.error('Erro ao carregar regiões.', e);
                })
                .finally((_) => {
                    this.loading.regiao = false;
                });
        },
        loadAllEstado() {
            if (this.estados.length == 0) {
                this.loadEstado();
            }
        },
        loadEstado(value) {
            this.loading.estado = true;

            this.estadoService
                .findAll(0, 100, value ? value : '')
                .then(this.mapItems)
                .then((allestados) => {
                    let o = allestados.filter(
                        (c) => this.estado && c.id.idestado == this.estado.id.idestado
                    )[0];
                    if (this.estado && !o) {
                        allestados.push(this.estado);
                    }
                    this.estados = allestados;
                    this.estados.sort();
                }, 350)
                .catch((e) => {
                    console.error('Erro ao carregar estados.', e);
                })
                .finally((_) => {
                    this.loading.estado = false;
                });
        },
        loadAllCidade() {
            if (this.cidades.length == 0) {
                this.loadCidade();
            }
        },
        loadCidade(value) {
            this.loading.cidade = true;

            this.cidadeService
                .findAll(0, 100, value ? value : '')
                .then(this.mapItems)
                .then((allcidades) => {
                    let o = allcidades.filter(
                        (c) => this.cidade && c.id.idcidade == this.cidade.id.idcidade
                    )[0];
                    if (this.cidade && !o) {
                        allcidades.push(this.cidade);
                    }
                    this.cidades = allcidades;
                    this.cidades.sort();
                }, 350)
                .catch((e) => {
                    console.error('Erro ao carregar cidades.', e);
                })
                .finally((_) => {
                    this.loading.cidade = false;
                });
        },
        loadAllColaborador() {
            if (this.promotores.length == 0) {
                this.loadColaborador();
            }
        },
        loadColaborador(value) {
            this.loading.promotor = true;
            let sort = {
                column: 'nome',
                order: 'asc',
            };
            this.colaboradorService
                .findAll(0, 100, sort, 2, value ? value : '')
                .then(this.mapItemsPromotor)
                .then((allpromotores) => {
                    let o = allpromotores.filter(
                        (c) => this.promotor && c.id.idusuario == this.promotor.id.idusuario
                    )[0];
                    if (this.promotor && !o) {
                        allpromotores.push(this.promotor);
                    }
                    this.promotores = allpromotores;
                    this.promotores.sort();
                }, 350)
                .catch((e) => {
                    console.error('Erro ao carregar colaboradores.', e);
                })
                .finally((_) => {
                    this.loading.promotor = false;
                });
        },
        loadAllCliente() {
            if (this.clientes.length == 0) {
                this.loadCliente();
            }
        },
        loadCliente(value) {
            this.loading.cliente = true;

            this.clienteService
                .findAll('nome', 'asc', 0, 100, 2, value ? value : '')
                .then(this.mapItemsPromotor)
                .then((allclientes) => {
                    let o = allclientes.filter(
                        (c) => this.cliente && c.id.idcliente == this.cliente.id.idcliente
                    )[0];
                    if (this.cliente && !o) {
                        allclientes.push(this.cliente);
                    }
                    this.clientes = allclientes;
                    this.clientes.sort();
                }, 350)
                .catch((e) => {
                    console.error('Erro ao carregar clientes.', e);
                })
                .finally((_) => {
                    this.loading.cliente = false;
                });
        },
        loadAllContrato() {
            if (this.contratos.length == 0) {
                this.loadContrato();
            }
        },
        loadContrato(value) {
            this.loading.contrato = true;

            this.contratoService
                .findAll(0, 100, value ? value : '')
                .then(this.mapItems)
                .then((allcontratos) => {
                    let o = allcontratos.filter(
                        (c) => this.contrato && c.id.idcontrato == this.contrato.id.idcontrato
                    )[0];
                    if (this.contrato && !o) {
                        allcontratos.push(this.contrato);
                    }
                    this.contratos = allcontratos;
                    this.contratos.sort();
                }, 350)
                .catch((e) => {
                    console.error('Erro ao carregar contrato.', e);
                })
                .finally((_) => {
                    this.loading.contrato = false;
                });
        },
        loadAllRede() {
            if (this.redes.length == 0) {
                this.loadRede();
            }
        },
        loadRede(value) {
            this.loading.rede = true;

            this.redeService
                .findAll('descricao', 'asc', 0, 100, 2, value ? value : '')
                .then(this.mapItems)
                .then((allredes) => {
                    let o = allredes.filter(
                        (c) => this.rede && c.id.idprorede == this.rede.id.idprorede
                    )[0];
                    if (this.rede && !o) {
                        allredes.push(this.rede);
                    }
                    this.redes = allredes;
                    this.redes.sort();
                }, 350)
                .catch((e) => {
                    console.error('Erro ao carregar redes.', e);
                })
                .finally((_) => {
                    this.loading.rede = false;
                });
        },
        loadAllBandeira() {
            if (this.bandeiras.length == 0) {
                this.loadBandeira();
            }
        },
        loadBandeira(value) {
            this.loading.bandeira = true;

            this.bandeiraService
                .findAll('descricao', 'asc', 0, 100, 2, value ? value : '')
                .then(this.mapItems)
                .then((allbandeiras) => {
                    let o = allbandeiras.filter(
                        (c) => this.bandeira && c.id.idprobandeira == this.bandeira.id.idprobandeira
                    )[0];
                    if (this.bandeira && !o) {
                        allbandeiras.push(this.bandeira);
                    }
                    this.bandeiras = allbandeiras;
                }, 350)
                .catch((e) => {
                    console.error('Erro ao carregar bandeiras.', e);
                })
                .finally((_) => {
                    this.loading.bandeira = false;
                });
        },
        loadAllLps() {
            if (this.lpss.length == 0) {
                this.loadLps();
            }
        },
        loadLps(value) {
            this.loading.lps = true;

            this.lpsService
                .findAll('nome', 'asc', 0, 100, 2, value ? value : '')
                .then(this.mapItemsPromotor)
                .then((alllpss) => {
                    let o = alllpss.filter((c) => this.lps && c.id.idlps == this.lps.id.idlps)[0];
                    if (this.lps && !o) {
                        alllpss.push(this.lps);
                    }
                    this.lpss = alllpss;
                    this.lpss.sort();
                }, 350)
                .catch((e) => {
                    console.error('Erro ao carregar LPSs.', e);
                })
                .finally((_) => {
                    this.loading.lps = false;
                });
        },
        loadAllTS() {
            if (this.tiposservicos.length == 0) {
                this.loadTS();
            }
        },
        loadTS(value) {
            this.loading.tiposervico = true;

            this.tiposervicoService
                .findAll('descricao', 'asc', 0, 100, 2, value ? value : '')
                .then(this.mapItems)
                .then((alltiposservicos) => {
                    let o = alltiposservicos.filter(
                        (c) =>
                            this.tiposervico &&
                            c.id.idtiposervico == this.tiposervico.id.idtiposervico
                    )[0];
                    if (this.tiposervico && !o) {
                        alltiposservicos.push(this.tiposervico);
                    }
                    this.tiposservicos = alltiposservicos;
                    this.tiposservicos.sort();
                }, 350)
                .catch((e) => {
                    console.error('Erro ao carregar tipos de serviço.', e);
                })
                .finally((_) => {
                    this.loading.tiposervico = false;
                });
        },
        loadAllGrupo() {
            if (this.grupos.length == 0) {
                this.loadGrupo();
            }
        },
        loadGrupo(value) {
            this.loading.grupo = true;
            let sort = {
                column: 'descricao',
                order: 'asc',
            };

            let empresa = '0, ';
            for (let e of this.empresas) {
                if (e.id > 0) {
                    empresa += `${e.id}, `;
                }
            }
            empresa = empresa.slice(0, -2);

            this.grupoService
                .findAll(0, 100, sort, 2, empresa, value ? value : '')
                .then(this.mapItems)
                .then((allgrupos) => {
                    let o = allgrupos.filter(
                        (c) => this.grupo && c.id.idgrupoproduto == this.grupo.id.idgrupoproduto
                    )[0];
                    if (this.grupo && !o) {
                        allgrupos.push(this.grupo);
                    }
                    this.grupos = allgrupos;
                    this.grupos.sort();
                }, 350)
                .catch((e) => {
                    console.error('Erro ao carregar grupos.', e);
                })
                .finally((_) => {
                    this.loading.grupo = false;
                    this.loadAllSubgrupo();
                });
        },
        loadAllSubgrupo() {
            if (this.subgrupos.length == 0) {
                this.loadSubgrupo();
            }
        },
        loadSubgrupo(value) {
            this.loading.subgrupo = true;
            let sort = {
                column: 'descricao',
                order: 'asc',
            };

            let grupo = '';
            for (let g of this.grupos) {
                grupo += `${g.id}, `;
            }
            grupo = grupo.slice(0, -2);

            this.subgrupoService
                .findAll(0, 100, sort, grupo, 2, value ? value : '')
                .then(this.mapItems)
                .then((allsubgrupos) => {
                    let o = allsubgrupos.filter(
                        (c) =>
                            this.subgrupo &&
                            c.id.idsubgrupoproduto == this.subgrupo.id.idsubgrupoproduto
                    )[0];
                    if (this.subgrupo && !o) {
                        allsubgrupos.push(this.subgrupo);
                    }
                    this.subgrupos = allsubgrupos;
                    this.subgrupos.sort();
                }, 350)
                .catch((e) => {
                    console.error('Erro ao carregar subgrupos.', e);
                })
                .finally((_) => {
                    this.loading.subgrupo = false;
                    this.loadAllLinha();
                });
        },
        loadAllLinha() {
            if (this.linhasprodutos.length == 0) {
                this.loadLinha();
            }
        },
        loadLinha(value) {
            this.loading.linha = true;

            let subgrupo = '';
            for (let g of this.subgrupos) {
                subgrupo += `${g.id}, `;
            }
            subgrupo = subgrupo.slice(0, -2);

            this.linhaService
                .findAll('descricao', 'asc', 0, 100, subgrupo, 2, value ? value : '')
                .then(this.mapItems)
                .then((alllinhas) => {
                    let o = alllinhas.filter(
                        (c) =>
                            this.linhaproduto &&
                            c.id.idlinhaproduto == this.linhaproduto.id.idlinhaproduto
                    )[0];
                    if (this.linhaproduto && !o) {
                        alllinhas.push(this.linhaproduto);
                    }
                    this.linhasprodutos = alllinhas;
                    this.linhasprodutos.sort();
                }, 350)
                .catch((e) => {
                    console.error('Erro ao carregar linhas.', e);
                })
                .finally((_) => {
                    this.loading.linha = false;
                });
        },
        loadAllProduto() {
            if (this.produtos.length == 0) {
                this.loadProduto();
            }
        },
        loadProduto(value) {
            this.loading.produto = true;
            let sort = {
                column: 'descricao',
                order: 'asc',
            };
            this.produtoService
                .findAll(0, 100, sort, value ? value : '')
                .then(this.mapItems)
                .then((allprodutos) => {
                    let o = allprodutos.filter(
                        (c) => this.produto && c.id.idproproduto == this.produto.id.idproproduto
                    )[0];
                    if (this.produto && !o) {
                        allprodutos.push(this.produto);
                    }
                    this.produtos = allprodutos;
                    this.produtos.sort();
                }, 350)
                .catch((e) => {
                    console.error('Erro ao carregar produtos.', e);
                })
                .finally((_) => {
                    this.loading.produto = false;
                });
        },
        updateRegiao(regiao) {
            this.atendimento.regioes = regiao;
        },
        updateEstado(estado) {
            this.atendimento.estados = estado;
        },
        updateCidade(cidade) {
            this.atendimento.cidades = cidade;
        },
        updateColaborador(colaborador) {
            this.atendimento.promotores = colaborador;
        },
        updateCliente(cliente) {
            this.atendimento.clientes = cliente;
        },
        updateContrato(contrato) {
            this.atendimento.contratos = contrato;
        },
        updateRede(rede) {
            this.atendimento.redes = rede;
        },
        updateBandeira(bandeira) {
            this.atendimento.bandeiras = bandeira;
        },
        updateLps(lps) {
            this.atendimento.lpss = lps;
        },
        updateTiposervico(tiposervico) {
            this.atendimento.tiposservicos = tiposervico;
        },
        updateGrupo(grupo) {
            this.atendimento.grupos = grupo;
        },
        updateSubgrupo(subgrupo) {
            this.atendimento.subgrupos = subgrupo;
        },
        updateLinha(linha) {
            this.atendimento.linhasprodutos = linha;
        },
        updateProduto(produto) {
            this.atendimento.produtos = produto;
        },
        updateExport(exportacao) {
            if (exportacao) {
                this.atendimento.formato = exportacao.id;
            } else {
                this.atendimento.formato = [];
                this.formato = null;
            }
        },
        updateResultOption() {
            this.isLoading = true;
            this.atendimentos = [];
            let field = this.fields.find((f) => f.key == 'numberRpShTpV');

            if (field != undefined) {
                switch (this.atendimento.tipo) {
                    case 'r':
                        field.label = 'ruptura';
                        field.visible = true;
                        break;
                    case 's':
                        field.label = 'share';
                        field.visible = true;
                        break;
                    case 't':
                        field.label = 'tomada-preco';
                        field.visible = true;
                        break;
                    case 'v':
                        field.label = 'vencimento';
                        field.visible = true;
                        break;
                    case 'f':
                        field.visible = false;
                        break;
                }

                this.tableKey++;
            }
            this.isLoading = false;
        },
        initDate() {
            this.atendimento.datainicial = (() => {
                let trintaDiasAtras = new Date();
                trintaDiasAtras.setDate(trintaDiasAtras.getDate() - 31);
                return trintaDiasAtras;
            })();
            this.atendimento.datafinal = new Date();
        },
        clearFields() {
            this.datasValidas = true;
            this.atendimentos = [];
            this.atendimento = {
                regioes: [],
                estados: [],
                cidades: [],
                promotores: [],
                clientes: [],
                contratos: [],
                redes: [],
                bandeiras: [],
                lpss: [],
                tiposservicos: [],
                grupos: [],
                subgrupos: [],
                linhasprodutos: [],
                produtos: [],
                datainicial: null,
                datafinal: null,
                tipo: 'r',
            };
            this.initDate();
        },
        searchFilter() {
            this.isSearching = true;
            this.service
                .getTableData(this.formattedAtendimento())
                .then((b) => {
                    this.isSearching = false;
                    if (b.content) {
                        this.atendimentos = b.content.map((c) => {
                            c['estado-descricao'] = c.estado.descricao;
                            c['cidade-descricao'] = c.cidade.descricao;
                            return c;
                        });
                    }

                    this.tableKey++;

                    setTimeout(() => {
                        this.$refs.resultsTable.currentSortColumn = {};
                    }, 50);
                })
                .catch((e) => (this.isSearching = false));
        },
        exportPPT() {
            this.isExportingPPT = true;
            this.service
                .getPPT(this.formattedPptAtendimento())
                .then((b) => {
                    this.isExportingPPT = false;
                    if (b.content) {
                        this.downloadPpt(b.content, 'Atendimento_');
                    }
                })
                .catch((e) => (this.isExportingPPT = false));
        },
        formattedPptAtendimento() {
            let a = { ...this.atendimento };
            a.regioes = a.regioes.map((m) => m.id);
            a.estados = a.estados.map((m) => m.id);
            a.cidades = a.cidades.map((m) => m.id);
            a.promotores = a.promotores.map((m) => m.id);
            a.clientes = a.clientes.map((m) => m.id);
            a.contratos = a.contratos.map((m) => m.id);
            a.redes = a.redes.map((m) => m.id);
            a.bandeiras = a.bandeiras.map((m) => m.id);
            a.lpss = a.lpss.map((m) => m.id);
            a.tiposservicos = a.tiposservicos.map((m) => m.id);
            a.grupos = a.grupos.map((m) => m.id);
            a.subgrupos = a.subgrupos.map((m) => m.id);
            a.linhasprodutos = a.linhasprodutos.map((m) => m.id);
            a.produtos = a.produtos.map((m) => m.id);
            a.formato = 'ppt';

            a.datainicial = this.$moment(this.atendimento.datainicial).format('YYYY-MM-DD');

            a.datafinal = this.$moment(this.atendimento.datafinal).format('YYYY-MM-DD');

            return a;
        },
        formattedAtendimento() {
            let a = { ...this.atendimento };
            a.regioes = a.regioes.map((m) => m.obj);
            a.estados = a.estados.map((m) => m.obj);
            a.cidades = a.cidades.map((m) => m.obj);
            a.promotores = a.promotores.map((m) => m.obj);
            a.clientes = a.clientes.map((m) => m.obj);
            a.contratos = a.contratos.map((m) => m.obj);
            a.redes = a.redes.map((m) => m.obj);
            a.bandeiras = a.bandeiras.map((m) => m.obj);
            a.lpss = a.lpss.map((m) => m.obj);
            a.tiposservicos = a.tiposservicos.map((m) => m.obj);
            a.grupos = a.grupos.map((m) => m.obj);
            a.subgrupos = a.subgrupos.map((m) => m.obj);
            a.linhasprodutos = a.linhasprodutos.map((m) => m.obj);
            a.produtos = a.produtos.map((m) => m.obj);

            a.datainicial = this.$moment(this.atendimento.datainicial).format('YYYY-MM-DD');

            a.datafinal = this.$moment(this.atendimento.datafinal).format('YYYY-MM-DD');

            return a;
        },
        changeStartDate(date) {
            this.atendimento.datainicial = date;
        },
        changeEndDate(date) {
            this.atendimento.datafinal = date;
        },
    },
};
</script>
<style lang="scss" scoped>
@import './mixins.scss';

.inicio-input,
.fim-input,
.item-input {
    @include default-size-column;
}

#main {
    padding: 0 15px 15px 21px;
    height: auto;
}
.page {
    position: relative;
    background-color: $sovis-white;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    padding: 20px;

    label {
        margin-bottom: 5px;
        font-size: 12px;
        color: #666666;
        font-weight: 600;
    }

    .data-table {
        padding: 10px 0 0 0;
    }

    .result-list {
        label {
            margin-bottom: 4px;
            font-size: 16px;
            color: #666666;
            font-weight: 600;
            width: auto;

            &:last-child {
                margin-bottom: 2px;
            }
        }
    }

    .atendimento .title {
        margin-bottom: 20px;
    }

    .filter {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-top: 20px;

        .items {
            display: flex;
            width: 79%;
            flex-wrap: wrap;
            justify-content: space-between;

            .item-input {
                width: 24%;
                margin-bottom: 5px;

                &.x2 {
                    width: 49%;
                }

                .dropdown {
                    // background-color: red;
                    height: 40px;
                }
            }
        }

        .result-options {
            width: 20%;
            display: flex;
            justify-content: flex-start;
            flex-direction: column;

            .block-events {
                pointer-events: none;
                opacity: 0.2;
            }

            label {
                width: 190px;

                input {
                    left: 0;
                }
            }

            .inicio-input input,
            .fim-input input {
                padding: 10px;
                border: 1px solid #e1e1e1 !important;
            }

            .fim-input {
                margin-top: 5px;
            }

            .exportar-input {
                margin-bottom: 5px;
            }
        }
    }
}
</style>
